var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReduceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#FB9B0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5826 26.3951C19.1928 25.785 20.1822 25.785 20.7924 26.3951L33.75 39.3528L41.5747 31.5281C42.1279 30.9749 43.0051 30.9161 43.6272 31.3907C48.1328 34.8277 51.5794 39.7294 53.1591 45.625L53.8004 48.0184L58.5434 39.8032C58.9749 39.0559 59.9305 38.7999 60.6779 39.2313C61.4252 39.6628 61.6813 40.6184 61.2498 41.3657L54.6207 52.8477C54.4135 53.2066 54.0722 53.4685 53.6719 53.5757C53.2716 53.683 52.8451 53.6268 52.4862 53.4196L41.0043 46.7905C40.2569 46.359 40.0009 45.4034 40.4323 44.6561C40.8638 43.9088 41.8194 43.6527 42.5668 44.0842L50.7819 48.8272L50.1406 46.4338C48.8724 41.701 46.2452 37.6992 42.7901 34.7321L34.8549 42.6674C34.2447 43.2775 33.2553 43.2775 32.6451 42.6674L18.5826 28.6049C17.9725 27.9947 17.9725 27.0053 18.5826 26.3951Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduceIcon);
export default __webpack_public_path__ + "static/media/reduce_icon.1f9732d29853ca0b3a3c3eca0f4db6ce.svg";
export { ForwardRef as ReactComponent };